import ConnectorListPresenter from "../ConnectorList/ConnectorList/ConnectorListPresenter";
import  { SingleChargePointModal } from "./SingleChargeInfo/SingleChargeInfoPresenter";
import SingleChargePointInfo from "./SingleChargeInfo/SingleChargePointInfo";

export const SingleChargePoint = {

   ModalSingleChargePoint : SingleChargePointModal,
   ConnectorList : ConnectorListPresenter,
   Info: SingleChargePointInfo
}

export default SingleChargePoint;